import { render, staticRenderFns } from "./TitlePages.vue?vue&type=template&id=a7378cce&scoped=true"
import script from "./TitlePages.vue?vue&type=script&lang=js"
export * from "./TitlePages.vue?vue&type=script&lang=js"
import style0 from "./TitlePages.vue?vue&type=style&index=0&id=a7378cce&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a7378cce",
  null
  
)

export default component.exports
import {QBtn,QImg} from 'quasar'
component.options.components = Object.assign(Object.create(component.options.components || null), component.options.components || {}, {QBtn,QImg})
